import React, { PropTypes } from 'react';

export default function Spinner(props) {
    let className = `Spinner ${props.active ? 'is-active' : ''}`;
    return (<div className={className}></div>);
}

Spinner.propTypes = {
    active: PropTypes.bool.isRequired
}